function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _typeof_1 = _typeof;
var typeofD4ZZ_FlZ = {
  _typeof: _typeof_1
};

var IS_BROWSER = (typeof window === "undefined" ? "undefined" : typeofD4ZZ_FlZ._typeof(window)) === 'object';
var _default = IS_BROWSER;
var indexCjs = /*#__PURE__*/Object.defineProperty({
  "default": _default
}, '__esModule', {
  value: true
});

export { indexCjs as i, typeofD4ZZ_FlZ as t };
//# sourceMappingURL=index-cjs-db83761d.js.map
